import { useLanguage } from "../lib/LanguageContext"

export default function HowItWorks() {
  const { t } = useLanguage()

  const STEPS = [
    { num: "01", title: t("how_step1_title"), desc: t("how_step1_desc") },
    { num: "02", title: t("how_step2_title"), desc: t("how_step2_desc") },
    { num: "03", title: t("how_step3_title"), desc: t("how_step3_desc") },
    { num: "04", title: t("how_step4_title"), desc: t("how_step4_desc") },
    { num: "05", title: t("how_step5_title"), desc: t("how_step5_desc") },
    { num: "06", title: t("how_step6_title"), desc: t("how_step6_desc") },
  ]

  return (
    <section id="how-it-works" className="bg-ink-800 py-24">
      <div className="container mx-auto max-w-content px-6 sm:px-16">
        <h2 className="mb-12 text-balance font-display text-4xl font-bold text-paper-0">{t("how_title")}</h2>
        <ol className="grid grid-cols-1 gap-x-8 gap-y-6 text-paper-0 min-[561px]:grid-cols-2 min-[1101px]:grid-cols-3">
          {STEPS.map((step) => (
            <li key={step.num} className="relative pt-32">
              <span
                aria-hidden="true"
                className="absolute -top-5 left-0 select-none font-display text-[6.5rem] font-bold leading-none text-gold-500/[.32]"
              >
                {step.num}
              </span>
              <div className="relative mb-3 font-semibold text-paper-0">{step.title}</div>
              <div className="relative text-sm leading-[1.7] text-fog-200">{step.desc}</div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
